module.exports = __webpack_public_path__ + "img/arrow_left.11911410.svg";